import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/amenitiesDetailsPages/EducationalHubPageComponent.tsx");
